module.exports = __webpack_public_path__ + "img/layout-1.b9b457c6.jpg";